import { z } from 'zod'
import { generatedAssetSchema } from './ai-studio-asset'
import { cropRectSchema } from './ai-studio-crop'
import { formatOutputSchema } from './ai-studio-format'

/** Credit cost of one edit apply; free, but kept explicit as the single source of truth. */
export const EDIT_CREDIT_COST = 0

export const editImageRequestSchema = z.object({
  crop: cropRectSchema.optional(),
  scaleWidth: z.number().int().positive().max(8000).optional(),
  brightness: z.number().min(0.5).max(1.5).default(1),
  saturation: z.number().min(0).max(2).default(1),
  contrast: z.number().min(0.5).max(1.5).default(1),
  grayscale: z.boolean().default(false),
  normalize: z.boolean().default(false),
  output: formatOutputSchema.default('webp'),
})

export type EditImageRequest = z.infer<typeof editImageRequestSchema>

export const editImageResponseSchema = z.object({
  asset: generatedAssetSchema,
})

export type EditImageResponse = z.infer<typeof editImageResponseSchema>
